import React from 'react';
import classNames from 'classnames';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentProjectHit as Type } from '../../../../SearchAllContent/types';
import { constructImageSourcesArray } from '../../../../../helpers/constructImageSources';
import { taxonomyTagElasticMapper } from '../../../../Tags/taxonomyTagMapper';
import useLayoutVariables from '../../../../../hooks/useLayoutVariables';

import Card from '../../../../Card';

import './style.scss';

const MetaSearchProjectHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const classes = classNames('MetaSearchHit', 'MetaSearchProjectHit');

  const {
    heroImageAspectRatio,
  } = useLayoutVariables('projectTeaser');

  return (
    <Card className={classes}>
      <Card.Content>
        <Card.Image
          image={(
            <Image
              src={constructImageSourcesArray(hit, heroImageAspectRatio)}
              alt={hit.image_alt?.[0]}
              lazyload={false}
            />
          )}
        />

        <div className="MetaSearchProjectHit__text-wrapper">
          <div className="Card__content__metadata">
            {hit.project_types_name?.[0] && (
              <div className="MetaSearchProjectHit__project-types">
                <Card.Tags tags={taxonomyTagElasticMapper(hit.project_types_name, 'project_types_name')} />
              </div>
            )}
            {hit.project_status_name?.[0] && (
              <div className="MetaSearchProjectHit__project-status">
                <Card.Tags tags={taxonomyTagElasticMapper(hit.project_status_name, 'project_status_name')} />
              </div>
            )}
          </div>

          <div className="Card__content__body">
            <Card.Link link={hit.url[0]}>
              <Card.Title title={hit.page_title[0]} />
            </Card.Link>

            <Card.Subtitle
              subtitle={(
                <p className="u-truncate--3">
                  {hit.body_summarized?.[0] ? (
                    hit.body_summarized[0]
                  ) : (
                    hit.body?.[0]
                  )}
                </p>
              )}
            />
          </div>
        </div>
      </Card.Content>
    </Card>
  );
};

export default MetaSearchProjectHit;
